import { I18nt } from 'utils';
import { ResultadoExamen } from 'utils/interfaces';
import { ExclamationCircleFilled, EyeFilled } from '@ant-design/icons';
import { useExamenesLabCtx } from 'pages/ExamenesLaboratorio/ExamenesLabContext';
import styles from './ResultadoCard.module.less';
import { Button } from 'antd';
import cn from 'classnames';

interface Props {
	resultado: ResultadoExamen;
}

function ResultadoCard({ resultado }: Props) {
	const { dispatch } = useExamenesLabCtx();
	const actionButton = () => {
		if (resultado.resultadoOculto) {
			return (
				<Button
					type='text'
					className={cn(styles.actionButton, styles.btnHideResult)}
					onClick={() =>
						dispatch({ type: 'showConsultaTuMedico', payload: true })
					}
				>
					<ExclamationCircleFilled />
					{I18nt('consulta_a_tu_meico')}
				</Button>
			);
		}
		return (
			<Button
				type='text'
				className={cn(styles.actionButton, styles.btnShowResult)}
				onClick={() => {
					dispatch({ type: 'showResultado', payload: resultado });
				}}
			>
				<EyeFilled />
				{I18nt('ver_resultado')}
			</Button>
		);
	};
	return (
		<div className={styles.resultado}>
			<div className={styles.resultadoWrapper}>
				<ul>
					<li>
						<strong>{I18nt('examen')}:</strong>
						{resultado.nombreExamen}
					</li>
					<li>
						<strong>{I18nt('tipo_de_examen')}:</strong>
						{resultado.tipoExamen}
					</li>
					<li>
						<strong>{I18nt('recibido_el')}:</strong>
						{resultado.fecha}
					</li>
				</ul>
				<div className={styles.BtnWrapper}>{actionButton()}</div>
			</div>
		</div>
	);
}

export default ResultadoCard;
